module.exports = __webpack_public_path__ + "more.svg?7dea42f4fdff886fa0dcae2c4542fe0f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more.svg
// module id = 297
// module chunks = 2